import { render } from "./SetNewPasswordPage.vue?vue&type=template&id=0b571172&scoped=true"
import script from "./SetNewPasswordPage.vue?vue&type=script&lang=js"
export * from "./SetNewPasswordPage.vue?vue&type=script&lang=js"

import "./SetNewPasswordPage.vue?vue&type=style&index=0&id=0b571172&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b571172"]])

export default __exports__